import Eyebrow from "../shared/Eyebrow";
import TypedHeading from "../shared/TypedHeading";
import Reveal from "../shared/Reveal";
import useI18n from "../../i18n/useI18n";

const handleSpotlight = (event) => {
  const card = event.currentTarget;
  const rect = card.getBoundingClientRect();
  card.style.setProperty("--mx", `${event.clientX - rect.left}px`);
  card.style.setProperty("--my", `${event.clientY - rect.top}px`);
};

const HomeServicesComponent = () => {
  const { t } = useI18n();
  const items = t("services.items");

  return (
    <section id="services" className="services section section--alt">
      <div className="services__inner">
        <div className="services__head">
          <div>
            <Reveal><Eyebrow>{t("services.eyebrow")}</Eyebrow></Reveal>
            <TypedHeading text={t("services.title")} className="services__title" />
          </div>
          <Reveal as="p" className="services__lede">{t("services.lede")}</Reveal>
        </div>

        <div className="services__grid">
          {Array.isArray(items) &&
            items.map((item, i) => (
              <Reveal
                key={i}
                as="article"
                className="service-card"
                delayMs={(i % 2) * 80}
              >
                <div className="service-card__hit" onMouseMove={handleSpotlight}>
                  <div className="spot" aria-hidden="true" />
                  <div className="service-card__body">
                    <div className="service-card__top">
                      <span className="service-card__num">{String(i + 1).padStart(2, "0")}</span>
                      <span className="service-card__arrow" aria-hidden="true">←</span>
                    </div>
                    <h3 className="service-card__title">{item.title}</h3>
                    <p className="service-card__desc">{item.desc}</p>
                    <ul className="service-card__points">
                      {item.points.map((point, pi) => (
                        <li key={pi}>
                          <span className="service-card__slash">/</span>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Reveal>
            ))}
        </div>
      </div>
    </section>
  );
};

export default HomeServicesComponent;
